import { createRouter, createWebHistory } from 'vue-router'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  scrollBehavior: () => ({ top: 0 }),
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('@/views/HomeView.vue')
    },
    {
      path: '/about',
      name: 'about',
      component: () => import('@/views/AboutView.vue')
    },
    {
      path: '/dashboard',
      name: 'dashboard',
      component: () => import('@/views/DashboardView.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/community',
      name: 'community',
      component: () => import('@/views/CommunityView.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/topic/:id',
      name: 'Details du topic',
      component: () => import('@/views/topic/TopicView.vue'),
      props: true,
      meta: { requiresAuth: true }
    },
    {
      path: '/topic/thread/:id',
      name: 'Details du thread',
      component: () => import('@/views/topic/ThreadView.vue'),
      props: true,
      meta: { requiresAuth: true }
    },
    {
      path: '/concours',
      name: 'concours',
      component: () => import('@/views/challenges/ConcoursView.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/register',
      name: 'register',
      component: () => import('@/views/account/RegisterView.vue')
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('@/views/account/LoginView.vue')
    },
    {
      path: '/resetPassword',
      name: 'resetPassword',
      component: () => import('@/views/account/ResetPasswordView.vue')
    },
    {
      path: '/actualities',
      name: 'Actualités',
      component: () => import('@/views/actus/ActuView.vue'),
      meta: { requiresAuth: false }
    },
    {
      path: '/article/:id',
      name: 'Article',
      component: () => import('@/views/actus/ArticleView.vue'),
      meta: { requiresAuth: false }
    },
    {
      path: '/tripdetails/:id',
      name: 'Details du trip',
      component: () => import('@/views/trips/TripDetailsView.vue'),
      props: true,
      meta: { requiresAuth: true }
    },
    {
      path: '/regions/:id',
      name: 'region',
      component: () => import('@/views/challenges/RegionView.vue'),
      props: true,
      meta: { requiresAuth: true }
    },
    {
      path: '/profil',
      name: 'Profil',
      component: () => import('@/views/profile/ProfileView.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/services',
      name: 'services',
      component: () => import('@/views/profile/ServicesView.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/map',
      name: 'map',
      component: () => import('@/views/map/MapView.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/contact',
      name: 'Contact',
      component: () => import('@/views/ContactView.vue')
    },
    {
      path: '/terms',
      name: 'Mentions légales',
      component: () => import('@/views/legal/TermsView.vue')
    },
    {
      path: '/admin/users',
      name: 'users',
      component: () => import('@/views/admin/UsersView.vue'),
      meta: {
        requiresAuth: true,
        isAdmin: true
      }
    },
    {
      path: '/admin/sendmail',
      name: 'sendmail',
      component: () => import('@/views/admin/SendMailView.vue'),
      meta: {
        requiresAuth: true,
        isAdmin: true
      }
    },
    {
      path: '/admin/trips',
      name: 'trips',
      component: () => import('@/views/admin/TripsView.vue'),
      meta: {
        requiresAuth: true,
        isAdmin: true
      }
    },
    {
      path: '/admin/gpx',
      name: 'trips',
      component: () => import('@/views/admin/GpxMultiImportView.vue'),
      meta: {
        requiresAuth: true,
        isAdmin: true
      }
    },
    {
      path: '/admin/panel',
      name: 'adminpanel',
      component: () => import('@/views/admin/AdminPanelView.vue'),
      meta: {
        requiresAuth: true,
        isAdmin: true
      }
    },
    {
      path: '/admin/feeback',
      name: 'feeback',
      component: () => import('@/views/admin/FeedBackView.vue'),
      meta: {
        requiresAuth: true,
        isAdmin: true
      }
    },
    {
      path: '/admin/articlebuilder',
      name: 'articlebuilder',
      component: () => import('@/views/admin/ArticleBuilderView.vue'),
      meta: {
        requiresAuth: true,
        isAdmin: true
      }
    },
    {
      path: '/admin/postbuilder',
      name: 'postbuilder',
      component: () => import('@/views/admin/PostBuilderView.vue'),
      meta: {
        requiresAuth: true,
        isAdmin: true
      }
    },
    {
      path: '/admin/leaderboard',
      name: 'leaderboard',
      component: () => import('@/views/admin/LeaderBoardView.vue'),
      meta: {
        requiresAuth: true,
        isAdmin: true
      }
    },
    {
      path: '/admin/concours',
      name: 'concoursdata',
      component: () => import('@/views/admin/ConcoursDataView.vue'),
      meta: {
        requiresAuth: true,
        isAdmin: true
      }
    },
    {
      path: '/test',
      name: 'Test',
      component: () => import('@/views/TestView.vue'),
      meta: {
        requiresAuth: true,
        isAdmin: true
      }
    },
    {
      path: '/:pathMatch(.*)*',
      name: 'NotFound',
      component: () => import('@/views/ErrorView.vue'),
      meta: { requiresAuth: false }
    },

  ]
})

export default router
